// Profile (cross-backend → admin-corev2). GET /profile.
import { adminRequest } from './client.js';

const api = {
	index: () => adminRequest('GET', '/profile'),
};

export default api;
